import {ObjModal} from './ObjModal';

export class DialogData {
  result: boolean;
  code: number;
  message: string;
  data: Array<ObjModal>;
}
